import React from 'react';
import { useSelector } from 'react-redux';

import FilterName from '@features/filter/v2/FilterName';
import DateRangeRightSidePanel from '@features/filter/v2/salesFunnel/DateRangeRightSidePanel';
import { allFilterPages } from '@features/filter/static/filterUtil';

import { collectionDateRangePresets } from '@utils/Util';

const DateRangeWrapper = ({ filterPageName, filterName = 'DATE_RANGE' }) => {
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);

	const getPresets = () => {
		if (
			filterName === 'CREATION_DATE' ||
			filterName === 'PUBLISH_DATE' ||
			filterName === 'PO_RECEIVED_DATE' ||
			filterName === 'EX_FACTORY_DATE' ||
			filterName === 'LAST_MODIFIED_DATE' ||
			filterName === 'PROJECT_DUE_DATE' ||
			(filterPageName === allFilterPages.MATERIAL_REQUISITION && filterName === 'REQUESTED_DATE') ||
			filterName === 'SOLD_DATE'
		) {
			return collectionDateRangePresets;
		} else {
			return undefined;
		}
	};

	return (
		<>
			<FilterName type={filterName} />
			{selectedField?.selectedCheckboxField === filterName && (
				<DateRangeRightSidePanel
					type={filterName}
					filterPageName={filterPageName}
					presets={getPresets()}
				/>
			)}
		</>
	);
};

export default DateRangeWrapper;
